import React, { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { get } from "../../../../../utils/api";

const MachineryNameFilter = ({
  selectedMachineryNames = [],
  setSelectedMachineryNames,
  url,
  errors,
}) => {
  const [machineryNames, setMachineryNames] = useState([]);

  useEffect(() => {
    const fetchMachineryNames = async () => {
      try {
        const response = await get(url);
        const uniqueNames = response.data.data
          ? [...new Set(response.data.data.map((machinery) => machinery.name))]
          : [];
        setMachineryNames(uniqueNames);
      } catch (error) {
        console.error("Error fetching machinery names:", error);
      }
    };

    fetchMachineryNames();
  }, [url]);

  const handleNameChange = (event) => {
    const selectedEquipmentType = event.target.value;
    if (event.target.checked) {
      setSelectedMachineryNames([
        ...selectedMachineryNames,
        selectedEquipmentType,
      ]);
    } else {
      setSelectedMachineryNames(
        selectedMachineryNames.filter(
          (country) => country !== selectedEquipmentType
        )
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        ml: 2,
        paddingBottom: "15%",
        height: "100%",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{ fontWeight: "bold", marginBottom: "30px" }}
      >
        Machinery Names
      </Typography>
      <Box className="scrollable-container">
        {machineryNames.length > 0 ? (
          machineryNames.map((name, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={name}
                  checked={selectedMachineryNames?.includes(name)}
                  onChange={handleNameChange}
                />
              }
              label={name || "Unknown Name"} // Fallback for missing names
            />
          ))
        ) : (
          <Typography>Loading machinery names...</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default MachineryNameFilter;
